import {
  Container,
  Box,
  Grid,
  IconButton,
  Link,
  Hidden,
  Button,
  Typography,
  Paper,
  FormControl,
  Select,
  MenuItem,
} from "@mui/material";
// import useStyles from "./styles";

import { CardElement } from "@stripe/react-stripe-js";
import { useSharedBookReducer } from "../state";

const SurfAbout = (props) => {
  const [bookState, dispatch] = useSharedBookReducer();

  const setJoinPeople = (e) => {
    dispatch({
      type: "MERGE",
      payload: {
        m: { joinpeople: e.target.value },
      },
    });
  };

  return (
    <>
      {bookState.m.type === "surfit" ? (
        <div>
          <p>
            The SurFit fitness weekly class is designed to get people{" "}
            <strong>out of the gym</strong> and enjoying functional{" "}
            <strong>fitness outdoors</strong>. We here at Big Surf love healthy
            lifestyles and combining <strong>mind, body, and nature</strong> all
            into one. Our classes are for ages
            <strong>15+</strong>. Participates can expect a{" "}
            <strong>2-3 hour class</strong> that varies week to week. Activities
            will include: surfing, beach yoga, surfboard yoga, stand up paddle
            boarding, dune climbs, paddle tug of war, stretching, body weight
            exercises, group relays, and HIIT workouts.
          </p>
        </div>
      ) : null}

      {bookState.m.type === "join" ? (
        <div>
          <p>
            Singles and groups of 2-3 looking to{" "}
            <strong>save a few bucks</strong> have the option of joining a small
            group lesson. This option is great for newbies and travelers to{" "}
            <strong>share their surfing journey with others</strong>. Students
            will be paired with up-to 5 other individuals (max 6 people per
            class). The instructor will be assisting all attendees as much as
            possible, however there will be a bit less individual attention than
            our private lessons. The curriculum will be the{" "}
            <strong>same as private group lessons</strong>. Must be 18 or older
            to join a group.
          </p>
        </div>
      ) : null}

      {bookState.m.type === "corp" ? (
        <div>
          <p>
            Corporate lessons are a great option for{" "}
            <strong>team building</strong> with a little something for everyone.
            We will host a <strong>variety of activities</strong>: surfing,
            boogie boarding, SUP, smash ball, relay races, beach volley ball
            matches, bocce ball, kite building. We provide{" "}
            <strong>catered lunch</strong> (pizza, Thai food, tacos, or poke)
            and snacks. We do have additional packages that include a{" "}
            <strong>day hike</strong>, 9 hole <strong>golf trip</strong> and{" "}
            <strong>wine tour</strong>
            in gorgeous Carmel Valley. Reservations must be booked in advance
            and prices vary based on the number of people and range of
            activities.
          </p>
        </div>
      ) : null}
    </>
  );
};

export default SurfAbout;
